import React from 'react';
import { useTask } from '../contexts/TaskContext';

function formatDate(ts) {
  if (!ts) return '';
  // Firestore Timestamp or Date 互換
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  if (isNaN(d.getTime())) return '';
  return `${d.getFullYear()}/${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')}`;
}

function getCompletedAtMs(ts) {
  if (!ts) return 0;
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return isNaN(d.getTime()) ? 0 : d.getTime();
}

export default function BucketListCompletedModal({ isOpen, onClose }) {
  const { bucketItems, restoreBucket, deleteBucket } = useTask();

  if (!isOpen) return null;

  // 達成日新しい順
  const completed = bucketItems
    .filter((it) => it.completed)
    .sort((a, b) => getCompletedAtMs(b.completedAt) - getCompletedAtMs(a.completedAt));

  const handleRestore = async (id) => {
    if (!window.confirm('この項目をバケットリストに戻しますか？')) return;
    await restoreBucket(id);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('この項目を完全に削除しますか？')) return;
    await deleteBucket(id);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content bucket-completed-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">
            <span aria-hidden="true">📋</span> 達成済み（{completed.length}）
          </h2>
          <button type="button" className="modal-close" onClick={onClose} aria-label="閉じる">
            ×
          </button>
        </div>

        <div className="modal-body">
          {completed.length === 0 ? (
            <div className="bucket-empty">
              <span className="empty-icon">🏁</span>
              <p>達成済みの項目はまだありません</p>
            </div>
          ) : (
            <ul className="bucket-completed-list">
              {completed.map((item) => (
                <li key={item.id} className="bucket-completed-row">
                  <div className="bucket-completed-main">
                    <span className="bucket-completed-name">{item.name}</span>
                    <span className="bucket-completed-date">
                      {formatDate(item.completedAt)} 達成
                    </span>
                  </div>
                  <div className="bucket-completed-actions">
                    <button
                      type="button"
                      className="bucket-edit-btn"
                      onClick={() => handleRestore(item.id)}
                      aria-label="復元"
                      title="バケットリストに戻す"
                    >
                      復元
                    </button>
                    <button
                      type="button"
                      className="bucket-delete-btn"
                      onClick={() => handleDelete(item.id)}
                      aria-label="削除"
                    >
                      削除
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="modal-footer">
          <button type="button" className="btn-primary" onClick={onClose}>
            閉じる
          </button>
        </div>
      </div>
    </div>
  );
}
